import React, {useState} from "react";

const PREVIEW = 8;

function VehicleEquipment({offer}) {

    const [expanded, setExpanded] = useState(false);

    const all = [
        ...offer.standardEquipment,
        ...offer.additionalEquipment,
    ];

    if (all.length === 0) return null;

    const visible    = expanded ? all : all.slice(0, PREVIEW);
    const half       = Math.ceil(visible.length / 2);
    const firstCol   = visible.slice(0, half);
    const secondCol  = visible.slice(half);

    return (
        <>
            <div className="vehicle-tabs__equip-table">
                <div className="vehicle-tabs__equip-col">
                    {firstCol.map((item, i) => (
                        <div key={i} className="vehicle-tabs__equip-item">{item}</div>
                    ))}
                </div>
                <div className="vehicle-tabs__equip-col">
                    {secondCol.map((item, i) => (
                        <div key={i} className="vehicle-tabs__equip-item">{item}</div>
                    ))}
                </div>
            </div>

            {all.length > PREVIEW && (
                <button
                    type="button"
                    className="vehicle-tabs__show-more"
                    onClick={() => setExpanded(e => !e)}
                >
                    {expanded ? 'Pokaż mniej' : 'Pokaż więcej'}
                    <span className={'vehicle-tabs__show-more-arrow' + (expanded ? ' up' : '')}>›</span>
                </button>
            )}

            {offer.availability !== 'IN_STOCK' && (
                <p className="vehicle-tabs__equip-note">
                    <em>Prezentowana oferta zawiera wyposażenie podstawowe samochodu.
                        Termin dostawy auta oraz ostateczna cena zostanie określona po uwzględnieniu
                        wybranego wyposażenia dodatkowego oraz rabatu GO-leasing.
                        Zapraszamy do kontaktu z naszym doradcą.</em>
                </p>
            )}
        </>
    );
}

export default VehicleEquipment;
